import React, { useEffect, useCallback } from 'react';
import { Box } from '@material-ui/core';
import { useDispatch } from 'dva';
import dayjs from 'dayjs';
import HeadML from './components/Head';
import Top5Card from './components/Top5Card';
import StaticPartML from './components/StaticPart';
import IndexStyled from './indexStyled';

export default () => {
  const dispatch = useDispatch();
  const yesterday = dayjs().subtract(1, 'day').format('YYYY-MM-DD');

  //今日行为数据概览
  const queryDataOverview = useCallback(() => {
    dispatch({
      type: 'behaviorData/queryDataOverview',
      payload: {
        startDate: yesterday,
        endDate: yesterday,
      },
    });
  }, [dispatch, yesterday]);

  //热门功能top
  const queryHighFrequencyFunction = useCallback(() => {
    dispatch({
      type: 'behaviorData/queryHighFrequencyFunction',
      payload: {
        queryDate: yesterday,
        topNum: 5,
      },
    });
  }, [dispatch, yesterday]);

  //查询权限组
  const queryAllRole = useCallback(() => {
    dispatch({
      type: 'behaviorData/queryAllRole',
      payload: {},
    });
  }, [dispatch]);

  useEffect(() => {
    queryDataOverview();
  }, [queryDataOverview]);

  useEffect(() => {
    queryHighFrequencyFunction();
  }, [queryHighFrequencyFunction]);

  useEffect(() => {
    queryAllRole();
  }, [queryAllRole]);

  return (
    <IndexStyled>
      <Box>
        <Box className="bar-style">
          <HeadML />
        </Box>
        <Box display="flex" gap="24px" mt={3}>
          {/* 左边 */}
          <Box width="100%" flexShrink="1" className="bar-style" display="flex">
            <StaticPartML />
          </Box>
          {/* 右边 */}
          <Box width="400px" flexShrink="0">
            <Top5Card />
          </Box>
        </Box>
      </Box>
    </IndexStyled>
  );
};
